//@ts-check
export function formatarValor(valor, casasDecimais) {
  let value = 0;

  if (valor == null) {
    return value;
  } else {
    if (typeof valor === "string") {
      return Number(valor.replace(",", ".")).toLocaleString("pt-br", {
        style: "decimal",
        minimumSignificantDigits: casasDecimais > 1 ? casasDecimais : 2,
      });
    } else {
      return valor.toLocaleString("pt-br", {
        style: "decimal",
        maximumFractionDigits: casasDecimais,
      });
    }
  }
}

export function formataCasasDecimaisMostrar(valor) {
  if (valor != null && valor.toString().indexOf(".") !== -1) {
    return valor.toFixed(2).toString().replace(".", ",");
  } else {
    return valor;
  }
}

/**
 *Checks if the user has the role with role passed
 *
 * @param {String} role
 * @param {Array.<object>} allRole
 * @param {Array.<object>} roleUsers
 * @returns
 */
export const isUserTemPermissao = (role, allRole, roleUsers) => {
  for (let i = 0; i < roleUsers.length; i++) {
    let permissao = allRole.filter(function (element) {
      return element.perfil === roleUsers[i].nomeRole;
    });
    if (permissao.length > 0) {
      let verifica = permissao[0].permissoes.filter(function (element) {
        return element === role;
      });
      if (verifica && verifica.length > 0) {
        return true;
      }
    }
  }
  return false;
};
